import ToastNotification from "./toast-notification";
import React from "react";
import { useTranslation } from "react-i18next";

export interface ToastNotificationBuiltinsProps {
	onDismiss?: () => void;
}

export function ToastNotificationNoInternet(
	props: ToastNotificationBuiltinsProps,
) {
	const { t } = useTranslation();
	return (
		<ToastNotification
			type="error"
			title={t("toasts.no_internet_title")}
			onDismiss={props.onDismiss}
		>
			{t("toasts.no_internet_body")}
		</ToastNotification>
	);
}

export function ToastNotificationExternalError(
	props: ToastNotificationBuiltinsProps,
) {
	const { t } = useTranslation();
	return (
		<ToastNotification
			type="error"
			title={t("toasts.error_retrieving_title")}
			onDismiss={props.onDismiss}
		>
			{t("toasts.error_retrieving_body")}
		</ToastNotification>
	);
}

export function ToastNotificationNoContent(
	props: ToastNotificationBuiltinsProps,
) {
	const { t } = useTranslation();
	return (
		<ToastNotification
			type="error"
			title={t("toasts.content_error_title")}
			onDismiss={props.onDismiss}
		>
			{t("toasts.content_error_body")}
		</ToastNotification>
	);
}
